export const Code = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.77258 22.2867L2.44044 15.9546L8.71873 9.67629" stroke="currentColor" stroke-width="2"/>
  <path d="M23.255 9.67627L29.5871 16.0085L23.3089 22.2867" stroke="currentColor" stroke-width="2"/>
  <path d="M18.6049 6.25854L13.3779 25.7505" stroke="currentColor" stroke-width="2"/>
</svg>`;
